import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
function LinkButton({ className, children, onClick, type = 'button', negative, disabled, }) {
    const colorClass = (() => {
        if (disabled) {
            return 'text-brand-text-content text-opacity-60';
        }
        if (negative) {
            return 'text-red-600 dark:text-red-500';
        }
        return 'text-brand-text-content';
    })();
    return (_jsx("button", { className: clsx('font-medium', { 'hover:underline': !disabled }, colorClass, className), 
        // a type is being provided but eslint doesn't know
        // eslint-disable-next-line react/button-has-type
        type: type, onClick: onClick, disabled: disabled, children: children }));
}
export { LinkButton };
//# sourceMappingURL=LinkButton.js.map